import { _ as __assign } from '../../chunks/bundle-CxLxJCBu.js';
import React__default from 'react';
import { G as GroupChannelHeaderView } from '../../chunks/bundle-CdrSitU9.js';
import { useChannelContext } from '../context.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-kFa80LJe.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-DOfhjbKd.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-C_zEpfCP.js';
import '../../chunks/bundle-BlguTwHI.js';
import '../../chunks/bundle-C3wdhLEG.js';
import '../../chunks/bundle-CjJk57u5.js';
import '../../chunks/bundle-DS1EhNtb.js';
import '../../chunks/bundle-Ci-RNuvu.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-d1cOX5nv.js';
import '../../ui/Header.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-B5157rdG.js';
import '../../ui/IconButton.js';
import '../../chunks/bundle-DXFVroy5.js';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-DRpjMk0B.js';
import '../../chunks/bundle-BA9oFJ90.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DiK8ifY3.js';
import '../../chunks/bundle-C-nZYnmy.js';
import '../../chunks/bundle-DP3z2QNm.js';
import 'react-dom';
import '../../ui/Button.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-DKdROCX_.js';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-DdJ9pMWn.js';
import '../../chunks/bundle-BzR1dD25.js';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-CpMvhj21.js';
import '../../chunks/bundle-AJS7Mngy.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-QgerWYLz.js';
import '../../chunks/bundle-CewnJAub.js';
import '../../chunks/bundle-CGb4JGZ-.js';
import '../../chunks/bundle-DXKWyDSR.js';
import '../../chunks/bundle-rPN_itAt.js';
import '../../chunks/bundle-D2HQ66dZ.js';
import '../../chunks/bundle-mqagBpi9.js';
import '../../chunks/bundle-BoENnpQQ.js';
import '../../chunks/bundle-B_14cMxa.js';
import '../../chunks/bundle-CbXgxoLr.js';
import '../../chunks/bundle-BW3AiewC.js';

var ChannelHeader = function (_a) {
    var className = _a.className;
    var context = useChannelContext();
    return (React__default.createElement(GroupChannelHeaderView, __assign({}, context, { className: className, currentChannel: context.currentGroupChannel })));
};

export { ChannelHeader, ChannelHeader as default };
//# sourceMappingURL=ChannelHeader.js.map
